import React, { useEffect, useState } from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import RecordPayment from './styles';
import FormPageHeader from '../../../../../components/shared/FormPageHeader';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import { getAllCustomerRef } from '../../customers/customer.service';
import { useFormik } from 'formik';
import { formatDate, showErrorSnackbar, showSnackbar, showSuccessSnackbar } from '../../../../../common/common.service';
import { Payment, PaymentMode } from '../payments.model';
import { CustomerRef } from '../../customers/customer.model';
import validation from './validation';
import { addPayment, editPayment, getPayment } from '../payment.service';
import { useSnackbar } from 'notistack';
import Loading from '../../../../../components/shared/Loading';
import { getAllCustomerRefRealTime } from '../../customers/customer.service';

const inputProps = {
  disableUnderline:true,
  style:{
    fontSize:'14px'
  }
  };

export default function(props: any): JSX.Element {
  const classes: any = RecordPayment();
  const [customerList, setCustomerList] = useState<CustomerRef[]>([]);
  const [editMode, setEditMode] = useState(false);
  const snackbar = useSnackbar();
  const [ loading, setLoading ] = useState<boolean>(false);
  const [ patch, setPatch ] = useState<boolean>(false);
  const [loadingText, setLoadingText] = useState<string>("");

  const setCustomers = async () => {
    getAllCustomerRefRealTime((customers: CustomerRef[]) => {
      setCustomerList(customers);
    })
  }

  const handleSubmit = (values: any) => {
    setLoading(true);
    const customer = customerList.find(cus => cus.id === values.customer);
    const payment = new Payment({...values, customer})
    if(editMode) {
      setEditMode(false);
      // editPayment(props.match.params.id, payment).then(data => {
      //   setLoading(false);
      //   showSuccessSnackbar(snackbar, 'Payment updated successfully!', true)
      //   formik.resetForm();
      //   props.history.push('/dashboard/payments/new');
      // }).catch(() => {
      //   setLoading(false);
      //   showErrorSnackbar(snackbar, 'Something went wrong!', true)
      // }); 
    
      editPayment(props.match.params.id, payment, (status: number) => {
        if(status === 5) {
          setLoading(false);
          props.history.push('/dashboard/payments');
          return;
        }
        if(!loading) {
          setLoading(true);
        }

        if(status === 0) {
          setLoadingText('Saving process 1/4');
        } else if(status === 1) {
          setLoadingText('Saving process 2/4');
        } else if(status === 3) {
          setLoadingText('Saving process 3/4');
        } else if(status === 4) {
          setLoadingText('Saving process 4/4');
        }
      })
    } else {
      addPayment(payment).then(data => {
        setLoading(false);
        showSuccessSnackbar(snackbar, 'Payment saved successfully!', true)
        formik.resetForm();
      }).catch(() => {
        setLoading(false);
        showErrorSnackbar(snackbar, 'Something went wrong!', true)
      }); 
    }
  }

  const formik = useFormik({
    initialValues: {
      customer: 'customerid',
      amount: 0,
      date: formatDate( new Date().toDateString()),
      transactionId: '',
      mode: PaymentMode.CASH
    },
    validationSchema: validation,
    validateOnChange: false,
    onSubmit: handleSubmit
  });

  const patchValues = async () => {
    setPatch(true);
    setLoading(true);
    setEditMode(true);
    // const payment: Payment = await getPayment(props.match.params.id);
    getPayment(props.match.params.id, (payment: Payment) => {
      formik.setValues({
        ...payment,
        customer: payment.customer.id,
        date: formatDate(payment.date)
      });
      setLoading(false);
      setPatch(false);
    });
  }

  useEffect(() => {
    setCustomers();
    if(props.match.params.id !== 'new') {
      patchValues();
    }
  }, []);

  const handleCancel = () => {
    showSnackbar(snackbar, 'Cancelled!', true, 1000)
    props.history.push('/dashboard/payments')
  }

  let customers: any[] = [
    <MenuItem key={99999999} value={'customerid'}>Select Customer</MenuItem>
  ];
  if(customerList.length) {
    const mappedCustomers = customerList.map((customer, index) => (
      <MenuItem key={index} value={customer.id}>{ customer.companyName }</MenuItem>
    ));
    customers.push(...mappedCustomers);
  }
    return (
    <div className={classes.main}>
      <header className={classes.header}>
        <FormPageHeader title="Record Payment" update={editMode} saveHandler={formik.handleSubmit} cancelText={editMode ? "Go back": undefined} cancelHandler={handleCancel}/>
      </header>

      <div className={classes.body}>
        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label} style={{color:"#112B42"}}>Company Name { formik.touched.customer && formik.errors.customer ? <span>{formik.errors.customer}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.custname}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              disabled={editMode}
              {...formik.getFieldProps('customer')}
            >
              { customers }
            </TextField>
            <br/>
          </div>
        </div>

        <div className={classes.labeltext} >
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}>Amount Received { formik.touched.amount && formik.errors.amount ? <span>{formik.errors.amount}</span> : null } </label><br/>
            <TextField
              type="number"
              InputProps={inputProps}
              className={classes.amntrcvd}
              onFocus={(e: any) => e.target.select()}
              {...formik.getFieldProps('amount')}
            />
            <br/>
          </div>
        </div>

        <div className={classes.labeltext}>
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}>Payment Date { formik.touched.date && formik.errors.date ? <span>{formik.errors.date}</span> : null } </label><br/>
            <TextField
              id="date"
              InputProps={inputProps}
              className={classes.date}
              type="date"
              onFocus={(e: any) => e.target.select()}
              {...formik.getFieldProps('date')}
              /><br/>
          </div>
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}>Transaction ID { formik.touched.transactionId && formik.errors.transactionId ? <span>{formik.errors.transactionId}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.textfield}
              onFocus={(e: any) => e.target.select()}
              {...formik.getFieldProps('transactionId')}
            />
            <br/>
          </div>
        </div>

        <div className={classes.labeltext}>
          <div className={classes.column1}>
            <label htmlFor="" className={classes.label}>Payment Mode { formik.touched.mode && formik.errors.mode ? <span>{formik.errors.mode}</span> : null } </label><br/>
            <TextField
              InputProps={inputProps}
              className={classes.paymode}
              select
              SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
              {...formik.getFieldProps('mode')}
            >
              <MenuItem value={PaymentMode.CASH}>{PaymentMode.CASH}</MenuItem>
              <MenuItem value={PaymentMode.CHEQUE}>{PaymentMode.CHEQUE}</MenuItem>
              <MenuItem value={PaymentMode.NEFT}>{PaymentMode.NEFT}</MenuItem>
              <MenuItem value={PaymentMode.RTGS}>{PaymentMode.RTGS}</MenuItem>
            </TextField><br/>
          </div>
        </div>
      </div>
      <Loading loading={loading} text={patch ? 'Loading....': loadingText}/>

    </div>   
  );
}